<template>
    <div class="field field--file">
        <span class="article-tag" v-bind:key="tag" v-for="tag in article.tags">
            {{tag}}
            <span class="article-tag__remove" @click="removeTag(tag)"><i class="material-icons">close</i></span>
        </span>


        <autocomplete v-model="add_tag" :matchingItems="matchingItems" @clickResult="clickResult" @enterResult="enter" displayProperty="tag" placeholder="Add Tag... e.g. BBC, Interview, News"/>
        <span class="enter-to-add" v-if="add_tag.length">[enter to add]</span>

    </div>
</template>

<script>
    import Autocomplete from '@/components/fields/Autocomplete.vue'

    export default {
        components: {
          Autocomplete,
        },
        props: [ 'article', 'tags'],
        data () {
            return {
                add_tag: '',
            }
        },
        computed: {
        },
        methods: {
            removeTag (tag) {
                this.article.tags.splice(this.article.tags.indexOf(tag), 1);
                this.$http.delete('/articles/'+this.$route.params.id+'/tags/'+tag+'/');
            },

            clickResult (tag){
                this.article.tags.push(tag.tag);
                this.add_tag = '';
            },

            enter (newTag) {
                if(newTag && newTag.length > 0){
                    this.add_tag = '';
                    if(this.article.tags.indexOf(newTag) !== -1 || newTag === 'All'){
                    }else{
                        this.article.tags.push(newTag);
                    }
                }
            },

            matchingItems (text){
              var results = []
              if(this.article){
                for(var i=0;i<this.tags.length;i++){
                  if(this.tags[i].tag.toLowerCase().indexOf(text.toLowerCase()) !== -1){
                    if(this.article.tags.indexOf(this.tags[i].tag) == -1){
                      results.push(this.tags[i])
                    }
                  }
                }
              }
              return results
            },

        },
    }
</script>
